export default class ContactModel {
  city: string;
  country: string;
  postalCode: string;
  province: string;
  officePhone: string;
  cellPhone: string;
  faxNumber: string;

  constructor(data: any) {
    this.city = data.city || undefined;
    this.country = 'Canada';
    this.postalCode = data.postalCode || undefined;
    this.province = data.province || undefined;
    this.officePhone = data.officePhone || undefined;
    this.cellPhone = data.cellPhone || undefined;
    this.faxNumber = data.faxNumber || undefined;
  }
}
